// Copyright (c) 2018 Deere & Company

import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetPartReturn = state =>
    PartReturn.update(state, {
        $set: getDefaultState().partReturn
    });

const updatePartRequest = (state, action) =>
    PartReturn.update(state, {
        $set: action.partReturn
    });

export default (state = getDefaultState().partReturn, action) => {

    const actionHandlers = {
        [actions.RESET_REQUEST_DETAILS]: resetPartReturn,
        [actions.UPDATE_REQUEST_DETAILS_PART_RETURN]: updatePartRequest
    };
    const reducer = actionHandlers[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/request-details/reducers/part-return.js